import { RouteContentHost } from "@eusoft/webapp-framework";
import { Class } from "@eusoft/webapp-jsx/components/Class";
import { Content } from "@eusoft/webapp-jsx/components/Content";
import { forModel } from "@eusoft/webapp-jsx/Helpers";
import { MaterialIcon,  type Content as UIContent } from "@eusoft/webapp-ui";
import { Action } from "@eusoft/webapp-ui/components/Action";
import { formatText } from "@eusoft/webapp-ui/utils/Format";
import { ContextView, type IContextInfo } from "./ContextView";
import "./AppContentHost.scss"
import { userSession } from "../services/UserSession";
import { BottomNav } from "@eusoft/webapp-framework/components/BottomNav";



const ContentHostTemplate = forModel<AppContentHost>(m => <main className={m.className}>
    <section className="content">

        <header>
            <Class name="hide-context" condition={!m.showContext || m.content?.hideContext} />
            <div className="action-bar">
                {m.content?.showBack && <Action name="back" onExecuteAsync={() => m.content?.host.closeAsync()} style="icon">❮</Action>}
                <span className="title">{formatText(m.content?.title)}</span>
                {m.supportContext && <Action name="toggle-context" style="icon" onExecuteAsync={() => m.toggleContext()} >
                    <MaterialIcon name="keyboard_arrow_down" />
                </Action>}
            </div>
            {m.supportContext && <ContextView />}
        </header>

        {m.content && <div className={m.content?.className}>

            <Class name="page" />

            <div className="body">
                <Content src={m.content?.body} update="" />
            </div>
            <footer>
                {m.content?.actions?.forEach(a =>
                    <Action visible={!a.canExecute || a.canExecute({})} name={a.name} type={a.type} onExecuteAsync={a.executeAsync}>
                        {a.icon}
                        {formatText(a.text)}
                    </Action>
                )}
            </footer>
        </div>}
    </section>
    <BottomNav ref={m.actionBar} visible={m.supportActionBar}  />
</main>)

export class AppContentHost extends RouteContentHost<UIContent & IContextInfo> {

    constructor() {
        super();

        this.init(AppContentHost);

        this.template = ContentHostTemplate;
    }


    protected override onMounted() {
        this.actionBar.addNav("home", "history-or-push");
    }

    override onContentLoaded() {
        this.showContext = false;
    }

    toggleContext() {
        this.showContext = !this.showContext;   
    }

    get supportContext() {
        return !this.content?.hideContext && userSession.isBusiness;
    }

    get supportActionBar() {
        return !this.content?.hideBottomNav;
    }

    actionBar: BottomNav;


    showContext: boolean = false;
}